import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Sale from '../../entities/cems/sale'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface SaleState extends ListState<Sale>{
    editModel: Sale;
    reportList: Array<any>;
    dealers: Array<any>;
    process: number;
    rate: number;
    series1: Array<number>;
    series2: Array<number>;
    series3: Array<number>;
    categories1: Array<any>;
    categories2: Array<any>;
    categories3: Array<any>;
    loadingDealers: boolean;
    loadingInds: boolean;
}
class SaleModule extends ListModule<SaleState,any,Sale>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Sale>(),
        loading:false,
        loadingDealers:false,
        loadingInds: false,
        editModel: new Sale(),
        activeList: new Array<Sale>(),
        reportList: new Array<any>(),
        dealers: new Array<any>(),
        process: null,
        rate: 0,
        series1: new Array<number>(),
        series2: new Array<number>(),
        series3: new Array<number>(),
        categories1: new Array<any>(),
        categories2: new Array<any>(),
        categories3: new Array<any>(),
        path: 'sales'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async importData(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/sales/import',
                payload.data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.reportList = response.data.result;
            return true;
        },
        async updateBatch(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/sales/batch', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async processApiSales(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/sales-api', payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return response.data.result;
        },
        async getDealers(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loadingDealers = true;
            let reponse = await Ajax.get('/api/sale-dealers', { params: payload.data }).catch(e => {
                context.state.loadingDealers = false;
                return Promise.reject(e);
            });
            context.state.loadingDealers = false;
            context.state.dealers = reponse.data.result;
        },
        async export(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/sales/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
        async getIndicators(context: ActionContext<SaleState, any>, payload: any) {
            context.state.loadingInds = true;
            let reponse = await Ajax.get('/api/cem-indicators', { params: payload.data }).catch(e => {
                context.state.loadingInds = false;
                return Promise.reject(e);
            });
            context.state.loadingInds = false;
            context.state.rate = reponse.data.result.rate;
            context.state.series1 = reponse.data.result.series1;
            context.state.series2 = reponse.data.result.series2;
            context.state.series3 = reponse.data.result.series3;
            context.state.categories1 = reponse.data.result.categories1;
            context.state.categories2 = reponse.data.result.categories2;
            context.state.categories3 = reponse.data.result.categories3;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: SaleState, model: Sale) {
            state.editModel = model;
            
        }, 
        new(state: SaleState, model: Sale) {
            state.editModel = Object.assign({});
        },
        setReportList(state: SaleState, list: Array<any>) {
            state.reportList = list;
        },
        setProcess(state: SaleState, value: number) {
            state.process = value;
        },
    });
}
const saleModule=new SaleModule();
export default saleModule;
